<template>
  <div class="advanced-dynamic-calibration">
    <div class="advanced-dynamic-calibration__panel">
      <div class="advanced-dynamic-calibration__panel__header">
        {{ $t('detail.moisture_calibration') }}
      </div>
      <div class="advanced-dynamic-calibration__panel__content">
        <div class="detail-settings">
          <div class="detail-settings__moisture_warning"
               v-if="!sensor.useBatchCalibration">
            <div class="msg1">{{ $t('detail.warning_device_calibration1') }}</div>
            <div class="msg2">{{ $t('detail.warning_device_calibration2') }}</div>
          </div>

          <div class="detail-settings__calibration_advanced">
            <div class="detail-settings__calibration_advanced__row">
              <div class="detail-settings__calibration_advanced__col">
                <label for="calibration-form-percent">{{$t('detail.percent')}}</label>
                <input type="text" id="calibration-form-percent" v-model="newPercentage">
              </div>
              <div class="detail-settings__calibration_advanced__col">
                <label for="calibration-form-raw">{{$t('detail.raw')}}</label>
                <input type="text" id="calibration-form-raw" v-model="newRaw">
              </div>
              <div class="detail-settings__calibration_advanced__col mini">
                <button
                        class="success mini-button"
                        @click="addCalibrationRangePoint"
                        :title="$t('detail.new_calib_point')">
                  <BaseIcon icon="tick" />
                </button>
              </div>
            </div>

            <div class="detail-settings__calibration_advanced__row">
              <div class="detail-settings__calibration_advanced__col">
                <span class="limit-percent">0%</span>
              </div>
              <div class="detail-settings__calibration_advanced__col">
                <span class="limit-percent-label">{{ $t('detail.raw_value') }}:</span>
                <span class="limit-percent-value">{{sensor.calibrationMin}}</span>
              </div>
            </div>

            <div class="detail-settings__calibration_advanced__row" v-if="false"><!-- added && false to hide button manually -->
              <div class="detail-settings__calibration_advanced__col">
                <span class="detail-settings__calibration__row__label">{{ $t('detail.measured_min') }}: </span>
                <span class="detail-settings__calibration__row__value"
                      v-if="sensor.calibrationMinPercentage === null">---</span>

                <span class="detail-settings__calibration__row__value"
                      v-if="sensor.calibrationMinPercentage !== null">
                  {{ (sensor.calibrationMinPercentage).toFixed(1) }} %
                </span>
              </div>
              <div class="detail-settings__calibration_advanced__col"
                   v-if="sensor.calibrationMinPercentage !== null">
                <button style="border: 1px solid lightcyan;" @click="calibrateDeviceMin">
                  {{ $t('detail.calibrate_min') }}
                </button>
              </div>
            </div>

            <div class="detail-settings__calibration_advanced__row option"
                 v-for="calibrationRange in sensor.calibrationRanges" :key="calibrationRange.id">
              <div class="detail-settings__calibration_advanced__col">
                <span class="percent">{{calibrationRange.percentage}}%</span>
              </div>
              <div class="detail-settings__calibration_advanced__col">
                <span class="percent-label">{{ $t('detail.raw_value') }}:</span>
                <span class="percent-value">{{calibrationRange.raw}}</span>
              </div>
              <div class="detail-settings__calibration_advanced__col mini">
                <button class="warning mini-button"
                        :title="$t('detail.remove_calib_point')"
                        @click="() => removeCalibrationRangePoint(calibrationRange.id)">
                  <BaseIcon icon="minus" />
                </button>
              </div>
            </div>

            <div class="detail-settings__calibration_advanced__row">
              <div class="detail-settings__calibration_advanced__col">
                <span class="limit-percent">100%</span>
              </div>
              <div class="detail-settings__calibration_advanced__col">
                <span class="limit-percent-label">{{ $t('detail.raw_value') }}:</span>
                <span class="limit-percent-value">{{sensor.calibrationMax}}</span>
              </div>
            </div>


            <div class="detail-settings__calibration_advanced__row" v-if="false"><!-- added && false to hide button manually -->
              <div class="detail-settings__calibration_advanced__col">
                <span class="detail-settings__calibration__row__label">{{ $t('detail.measured_max') }}: </span>
                <span class="detail-settings__calibration__row__value"
                      v-if="sensor.calibrationMaxPercentage === null">---</span>
                <span class="detail-settings__calibration__row__value"
                      v-if="sensor.calibrationMaxPercentage !== null">
                  {{ (sensor.calibrationMaxPercentage).toFixed(1) }} %
                </span>
              </div>
              <div class="detail-settings__calibration_advanced__col"
                   v-if="sensor.calibrationMaxPercentage !== null">
                <button style="border: 1px solid lightcyan;"  @click="calibrateDeviceMax">
                  {{ $t('detail.calibrate_max') }}
                </button>
              </div>
            </div>


            <div class="detail-settings__calibration__actions">
              <div class="detail-settings__calibration__row size-2"
                   v-if="!sensor.useBatchCalibration && isUserDealer()">
                <button @click="$modal.show('apply-calibration-to-batch')" class="success">
                  {{ $t('detail.apply_calib') }}
                </button>
              </div>
              <div class="detail-settings__calibration__row size-2" v-if="false">
                <button @click="resetCalibrationForSensor" class="danger">
                  {{ $t('detail.reset_minmax') }}
                </button>
              </div>
              <div class="detail-settings__calibration__row size-2"
                   v-if="!sensor.useBatchCalibration">
                <button @click="resetCalibration" class="danger">
                  {{ $t('detail.reset_calib') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="apply-calibration-to-batch" :adaptive="true" :height="'auto'"
           class="apply-calibration-to-batch">
      <div class="modal-title">{{ $t('detail.select_props') }}
        <a @click="closeModal" class="close">x</a>
      </div>
      <BatchSelection :batch="batch" :device="device" :disabledActions="true"
                      :resultData="selectedBatchProperties"></BatchSelection>
      <div class="modal__actions">
        <div class="detail-settings__calibration__row size-2">
          <button class="success" @click="submitStateToBatch">
            {{ $t('detail.save_props') }}
          </button>
          <button @click="closeModal" class="danger">
            {{ $t('buttons.cancel') }}
          </button>
          <div class="clearfix"></div>
        </div>
      </div>
    </modal>

    <modal name="warning-modal" :adaptive="true" :height="'auto'"
           class="apply-calibration-to-batch">
      <div class="modal-title">{{ $t('detail.warning') }}
        <a @click="$modal.hide('warning-modal')" class="close">x</a>
      </div>
      <div class="modal-message">
        {{ $t('detail.warning_vwc') }}
      </div>
      <div class="modal__actions">
        <div class="detail-settings__calibration__row size-2">
          <button @click="$modal.hide('warning-modal')" class="danger right">
            {{ $t('buttons.ok') }}
          </button>
          <div class="clearfix"></div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import BatchSelection from '@/views/detail/BatchSelection.vue';
import store from '@/store';

export default {
  name: 'DetailSettingsRow',
  components: { BatchSelection },
  props: {
    batch: {
      type: Object,
      required: true,
    },
    device: {
      type: Object,
      required: true,
    },
    sensor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      secondaryBatchOriginal: '',
      secondaryBatch: null,
      secondaryBatchId: null,
      secondaryBatchOriginalId: null,
      m: Object.assign({}, this.device.properties),
      deviceOnly: !this.sensor.useBatchCalibration,
      deviceOnlyOriginal: !this.sensor.useBatchCalibration,
      newRaw: '',
      newPercentage: '',
      modal: false,
      selectedBatchProperties: {},
    };
  },
  methods: {
    isUserDealer() {
      let user = this.$store.getters['tentacle/user'];
      return user ? user.is_dealer : false;
    },
    submitStateToBatch() {
      const attr = {
        id: this.sensor.id,
        properties: this.selectedBatchProperties.properties,
      };

      this.$store.dispatch('tentacle/calibrateBatchBySensor', attr).then(() => {
        this.refreshCalibrationData();
        this.closeModal();
        this.$emit('changedBatch');
        this.flash('The calibration for the sensor has been done.', 'success');
      });
    },
    validateNewCalibrationRange() {
      const floatedRaw = parseFloat(this.newRaw);
      const floatedPercentage = parseFloat(this.newPercentage);
      const validRaw = !Number.isNaN(floatedRaw);
      const validPercentage = !Number.isNaN(floatedPercentage);
      const parsedCalibMin = parseFloat(this.sensor.calibrationMin);
      const parsedCalibMax = parseFloat(this.sensor.calibrationMax);

      const inRange = parsedCalibMin > parsedCalibMax ?
              (this.sensor.calibrationMin == null || floatedRaw < parsedCalibMin) && (this.sensor.calibrationMax == null || floatedRaw > parsedCalibMax):
              (this.sensor.calibrationMin == null || floatedRaw > parsedCalibMin) && (this.sensor.calibrationMax == null || floatedRaw < parsedCalibMax);


      const firstStepValidation = floatedPercentage > 0 && floatedPercentage < 100 && validRaw && validPercentage && inRange;

      if (firstStepValidation && this.sensor.calibrationRanges) {
        for (let i = 0; i < this.sensor.calibrationRanges.length; i += 1) {
          const calibrationRangePct = parseFloat(this.sensor.calibrationRanges[i].percentage);
          const calibrationRangeRaw = parseFloat(this.sensor.calibrationRanges[i].raw);

          if (calibrationRangePct === floatedPercentage) {
            return false;
          }

          if (calibrationRangeRaw === floatedRaw) {
            return false;
          }

          // 1400 > 180 true
          // 10 > 15 false && 550 > 700 false

          let upperRangeOfOthers = parsedCalibMin > parsedCalibMax ?
                  calibrationRangePct > floatedPercentage && calibrationRangeRaw > floatedRaw:
                  calibrationRangePct > floatedPercentage && calibrationRangeRaw < floatedRaw;
          if (upperRangeOfOthers) {
            return false;
          }

          // 1400 > 180 true
          // 10 < 15 true && 550 < 700 true

          let lowerRangeOfOthers = parsedCalibMin > parsedCalibMax ?
                  calibrationRangePct < floatedPercentage && calibrationRangeRaw < floatedRaw:
                  calibrationRangePct < floatedPercentage && calibrationRangeRaw > floatedRaw;
          if (lowerRangeOfOthers) {
            return false;
          }
        }
      }

      return firstStepValidation;
    },
    closeModal() {
      this.$modal.hide('apply-calibration-to-batch');
    },
    refreshCalibrationData() {
      store.dispatch('tentacle/setUnitByID', this.device.id);
      this.deviceOnlyOriginal = this.deviceOnly;
    },

    /* calibrateBatchMin() {
      const attr = {
        min: true,
        max: false,
        sensorId: this.sensor.id,
      };

      this.$store.dispatch('tentacle/calibrateBatchBySensor', attr).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor has been done.', 'success');
      });
    },
    calibrateBatchMax() {
      const attr = {
        min: false,
        max: true,
        sensorId: this.sensor.id,
      };

      this.$store.dispatch('tentacle/calibrateBatchBySensor', attr).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor has been done.', 'success');
      });
    }, */

    calibrateDeviceMin() {
      const attr = {
        min: true,
        max: false,
        sensorId: this.sensor.id,
      };

      this.$store.dispatch('tentacle/calibrateDeviceSensor', attr).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor has been done.', 'success');
      });
    },

    calibrateDeviceMax() {
      const attr = {
        min: false,
        max: true,
        sensorId: this.sensor.id,
      };

      this.$store.dispatch('tentacle/calibrateDeviceSensor', attr).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor has been done.', 'success');
      });
    },
    addCalibrationRangePoint() {
      if (!this.validateNewCalibrationRange()) {
        this.$modal.show('warning-modal');
        return;
      }

      this.addCalibrationRangePointForSensor();
    },
    removeCalibrationRangePoint(calibrationId) {
      this.removeCalibrationValueFromSensor(calibrationId);
    },
    addCalibrationRangePointForSensor() {
      const attr = {
        id: this.sensor.id,
        raw: this.newRaw,
        percentage: this.newPercentage,
      };

      this.$store.dispatch('tentacle/addCalibrationValueToSensor', attr).then(() => {
        this.refreshCalibrationData();
        this.newRaw = '';
        this.newPercentage = '';
        this.flash('The calibration for the sensor has been done.', 'success');
      });
    },
    removeCalibrationValueFromSensor(calibrationId) {
      const attr = {
        sensorId: this.sensor.id,
        calibrationId,
      };

      this.$store.dispatch('tentacle/removeCalibrationValueFromSensor', attr).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor was successfully removed.', 'success');
      });
    },
    /* addCalibrationRangePointForBatch() {
      const attr = {
        id: this.sensor.id,
        raw: this.newRaw,
        percentage: this.newPercentage,
      };

      this.$store.dispatch('tentacle/addCalibrationValueToBatch', attr).then(() => {
        this.refreshCalibrationData();
        this.newRaw = '';
        this.newPercentage = '';
        this.flash('The calibration for the sensor has been done.', 'success');
      });
    },
    removeCalibrationValueFromBatch(calibrationId) {
      const attr = {
        sensorId: this.sensor.id,
        calibrationId,
      };

      this.$store.dispatch('tentacle/removeCalibrationValueFromBatch', attr).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor was successfully removed.', 'success');
      });
    }, */
    calibrateDevice() {
      this.$store.dispatch('tentacle/calibrateDeviceSensor', this.sensor.id).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor has been done.', 'success');
      });
    },
    resetCalibrationForSensor() {
      const data = {
        id: this.sensor.id,
        calibrationMeasuredMinValue: 'null',
        calibrationMeasuredMaxValue: 'null',
      };
      this.$store.dispatch('tentacle/updateSensors', [data]).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor has been reset.', 'success');
      });
    },
    resetCalibration() {
      const data = {
        id: this.sensor.id,
        useBatchCalibration: true,
      };
      this.$store.dispatch('tentacle/updateSensors', [data]).then(() => {
        this.refreshCalibrationData();
        this.flash('The calibration for the sensor has been reset.', 'success');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.advanced-dynamic-calibration {
  margin-top: 4rem;
  padding-left: 8rem;
  @media only screen and (max-width: 990px) {
    padding-left: 0;
    width: 90%;
    margin-right: auto;
    margin-left: 5%;
  }
  @media only screen and (min-width: 991px) and (max-width: 1199px) {
    padding-left: 0;
    width: 90%;
    margin-right: auto;
    margin-left: 5%;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1400px) {
    margin-left: -4%;
    width: 100%;
  }

  &__panel {
    border-radius: 2rem;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
    position: relative;

    .loading-wrapper {
      position: absolute;
      top: 5rem;
      width: 100%;
      height: calc(100% - 10rem);
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
    }

    &__header {
      padding: 0 3rem;
      height: 6rem;
      border-bottom: 0.1rem solid $border-color;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 1.4rem;
      color: $grey;
    }

    &__content {
      padding: 2rem 3rem;
      font-size: 1.3rem;
      @media only screen and (max-width: 1400px) {
        min-height: 26rem;
      }
    }
  }
}

.detail-settings {
  &__moisture_warning {
    .msg1 {
      color: #ea7575;
    }

    .msg2 {
      margin-top: 10px;
      color: #ffc90e;
    }

    font-size: 1.6rem;
    margin-bottom: 1rem;
    font-weight: bold;
  }

  &__device-only {
    color: #f39c12;
    font-weight: bold;
    margin-left: -5px;
  }

  &__calibration {
    padding: 3.5rem 0;
    font-size: 1.3rem;
    display: flex;
    flex-wrap: wrap;

    &__col3 {
      padding-top: 1.2rem;
      flex: 1 0 62%;
    }

    &__row {
      line-height: 3.3rem;

      &.size-2 {
        line-height: 3.8rem;
      }

      &__label-selection {
        font-weight: bold;
        min-width: 155px;
        display: inline-block;

        &.calibrated_by {
          font-weight: normal;
          margin-top: 20px;
          color: darkblue;
        }
      }

      &__label {
        font-weight: bold;
        min-width: 125px;
        display: inline-block;

        &.calibrated_by {
          font-weight: normal;
          margin-top: 20px;
          color: darkblue;
        }
      }

      .info-text {
        color: $grey;
      }

      &__value {
        .strong {
          color: #ff5050;
        }
      }
    }

    &__actions {
      margin-top: 10px;
      button {
        margin-top: 10px;
        width: 70%;
        color: $white;
        font-size: 1.5rem;

        &.success {
          background-color: #b2de4d;
          border: none;

          &:hover {
            background-color: #9ec94e;
          }
        }

        &.danger {
          background-color: #ea7575;
          border: none;

          &:hover {
            background-color: rgba(214, 91, 91, 1);
          }
        }
      }
    }
  }

  &__calibration_advanced {
    font-weight: bold;

    input {
      border: none;
      border-bottom: 1px solid black;
      width: 90px;
      margin-left: 8px;
    }

    button {
      border-radius: 4px;
      padding: 10px 20px;
      font-weight: bold;
      cursor: pointer;
    }

    &__row {
      padding: 1rem 0;
    }

    &__col {
      width: 40%;
      display: inline-block;

      &.mini {
        width: 10%;
        margin-left: -5%;

        button {
          border-radius: 4px;
          width: 36px;
          font-size: 8px;
          text-align: center;
          padding: 3px 6px 2px 5px;
          cursor: pointer;

          &.success {
            background-color: #b2de4d;
            border: none;

            &:hover {
              background-color: #9ec94e;
            }
          }

          &.warning {
            background-color: #ff5050;
            border: none;

            &:hover {
              background-color: rgba(214, 91, 91, 1);
            }
          }
        }
      }

      &:first-child {
        margin-right: 10%;
      }

      .limit-percent-label,
      .percent-label {
        margin-right: 5px;
      }

      .limit-percent,
      .limit-percent-value,
      .limit-percent-label {
        color: #bbb;
      }
    }
  }
}

.modal-title {
  font-weight: 600;
  font-size: 1.4rem;
  color: $grey;
  height: 6rem;
  padding: 0 3rem;
  border-bottom: 0.1rem solid $border-color;
  align-items: center;
  display: flex;

  .close {
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 2rem;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: black;
    }
  }
}

/** modal **/
.apply-calibration-to-batch {
  .detail-settings__calibration {
    padding: 0 3rem;
  }

  .modal__actions {
    padding: 0 3rem 2rem;
  }

  .modal-message {
    padding: 2rem 3rem 0;
    font-size: 1.5rem;
  }

  button {
    &:first-child:not(.right) {
      width:65%;
      float:left;
    }

    width: 30%;
    float:right;
    margin-top: 20px;
    color: $white;
    font-size: 1.5rem;
    padding: 10px;
    font-weight: 800;
    cursor: pointer;

    &.success {
      background-color: #b2de4d;
      border: none;

      &:hover {
        background-color: #9ec94e;
      }
    }

    &.danger {
      background-color: #ea7575;
      border: none;

      &:hover {
        background-color: rgba(214, 91, 91, 1);
      }
    }
  }

  .clearfix {
    clear: both;
  }
}

</style>
